import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';

function digits6(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 6);
}

export default function PinSetup({
  pin,
  confirmPin,
  onPin,
  onConfirm,
  onSubmit,
  onSkip,
  loading,
  title = 'ตั้ง PIN สำหรับเข้าสู่ระบบ',
  lead = 'PIN 6 หลัก ใช้แทนรหัสผ่านได้ตอนเข้าสู่ระบบ ห้ามซ้ำ PIN เดิม ห้ามเลขเรียง และห้ามใช้วันเดือนปีเกิด',
  hideSkip = false,
}) {
  return (
    <Stack spacing={2}>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" color="text.secondary">
        {lead}
      </Typography>
      <TextField
        label="PIN 6 หลัก"
        value={pin}
        onChange={(e) => onPin(digits6(e.target.value))}
        inputProps={{ inputMode: 'numeric', maxLength: 6, autoComplete: 'off' }}
      />
      <TextField
        label="ยืนยัน PIN"
        value={confirmPin}
        onChange={(e) => onConfirm(digits6(e.target.value))}
        inputProps={{ inputMode: 'numeric', maxLength: 6, autoComplete: 'off' }}
      />
      <LoadingButton fullWidth type="button" variant="contained" loading={loading} onClick={onSubmit}>
        ตั้ง PIN
      </LoadingButton>
      {hideSkip ? null : (
        <Button fullWidth type="button" onClick={onSkip} disabled={loading}>
          ไว้ทีหลัง
        </Button>
      )}
    </Stack>
  );
}

PinSetup.propTypes = {
  pin: PropTypes.string,
  confirmPin: PropTypes.string,
  onPin: PropTypes.func,
  onConfirm: PropTypes.func,
  onSubmit: PropTypes.func,
  onSkip: PropTypes.func,
  loading: PropTypes.bool,
  title: PropTypes.string,
  lead: PropTypes.string,
  hideSkip: PropTypes.bool,
};
